import React from "react";
import { Trans, useTranslation } from "react-i18next";

import McAlert from "../../../../../components/Alert";

import { SUPPORT_LINK_ORG_ACCOUNT_PRE_REQUISITE } from "../../../../../config/service";

const ConnectManagementAccountInfo = () => {
  const { t } = useTranslation("addAccount");

  return (
    <McAlert
      type="info"
      content={
        <div>
          <strong className="mc-text-base">
            {t("addAccount:orgOnboarding.preRequisite.title")}
          </strong>
          <div>
            <Trans
              i18nKey="addAccount:orgOnboarding.preRequisite.step1"
              components={[
                <a
                  href={SUPPORT_LINK_ORG_ACCOUNT_PRE_REQUISITE}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                </a>,
              ]}
            />
          </div>
        </div>
      }
      className="mb-4"
    />
  );
};

export default ConnectManagementAccountInfo;
